import BaseLayout from "../../layouts/BaseLayout";
import { Chat } from "@vojomo-core/shared";
import { ModusProvider, useModus } from "@vojomo-core/shared";
import styles from "./Chat.module.css";

export const Modus = () => {
  return (
    <ModusProvider>
      <ModusInternal />
    </ModusProvider>
  );
};

export const ModusInternal = () => {
  const { agentsList } = useModus();

  if (agentsList.length == 0) {
    return <></>;
  }

  return (
    <BaseLayout pageTitle="Modus">
      <div>
        <h3 className="mb-0 pb-0">Modus</h3>
        <div className={styles.modusContainer}>
          <Chat
            agent={agentsList[0].value}
            agentSelector={true}
            showTranscriptIcon={true}
          />
        </div>
      </div>
    </BaseLayout>
  );
};
